<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white"> Formulario </h4>
            </div>
            <div class="card-body">
                <form>
                    <br>
                    <div class="float-left col-md-5">
                        <!--====META DE SUCURSAL-->
                        <div class="float-left col-md-8">
                            <h3>Sucursal: {{fnombre}} </h3>
                            <h3>Meta de sucursal: {{fmeta}}</h3>
                            <br>
                            <h6>Total cobrado en bancos</h6>
                            <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="tcb" [(ngModel)]="tcb" (ngModelChange)="mostraruno()" />
                            <hr style="width: 0%">
                            <h6>Total cobrado por jurídico</h6>
                            <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="tcj" [(ngModel)]="tcj" (ngModelChange)="mostraruno()" />
                            <hr style="width: 0%">
                            <h6>Cobranza externa</h6>
                            <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="c_ext" [(ngModel)]="c_ext" (ngModelChange)="mostraruno()" />
                            <hr style="width: 0%">
                            <h6>Total: </h6>
                            <h6 class="btn btn-block">{{converuno}}</h6>
                            <!--
                                <h6>{{converuno}}</h6>
                            <input class="btn btn-secondary" type="submit" name="Enviar" id="ejemplo1" (click)="mostraruno()" />
                            -->
                            <hr style="border-color:black">
                            <hr style="border-color:black">
                            <br>
                        </div>
                        <!--00000-->
                        <div class="float-left col-md-8">
                            <h6>Cobranza renta con IVA</h6>
                            <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="c_rrIVA" [(ngModel)]="c_rrIVA" required (ngModelChange)="mostrardos()" />
                            <hr style="width: 0%">
                            <h6>Cobranza venta con IVA</h6>
                            <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="cvcI" [(ngModel)]="cvcI" required (ngModelChange)="mostrardos()" />
                            <hr style="width: 0%">
                            <h6>Cobranza total según edo cta.</h6>
                            <h6 class="btn btn-block">{{converdos}}</h6>
                            <!-- <input class="btn btn-secondary" type="submit" name="Enviar" id="ejemplo2" (click)="mostrardos()" /> -->
                            <hr style="border-color:black">
                            <hr style="border-color:black">
                            <br>
                        </div>
                        <!--====Fin Meta de sucursal=====-->
                        <!--====Cobranza Renta con IVA====-->
                        <div class="float-left col-md-8">
                            <!--====Cobranza sin IVA renta====-->
                            <h6>Cobranza sin IVA renta</h6>
                            <h6>{{convertre}}</h6>
                            <hr style="width: 0%">
                            <h6>Menos: Sueldos de montaje (horas extra)</h6>
                            <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="menosSueldosMontaje" [(ngModel)]="menosSueldosMontaje" required (ngModelChange)="mostrartres()" />
                            <hr style="width: 0%">
                            <h6>Menos: Gastos</h6>
                            <h6>{{converoch}}</h6>
                            <hr style="width: 0%">
                            <h6>Total cobranza renta</h6>
                            <h6 class="btn btn-block">{{convernue}}</h6>
                            <!--<input class="btn btn-secondary" type="submit" name="Enviar" id="ejemplo3" (click)="mostrartres()" />-->
                            <hr style="border-color:black">
                            <hr style="border-color:black">
                            <br>
                        </div>
                        <!--==================================-->
                    </div>
                    <!--Integración por gastos-->
                    <div class="float-right col-md-6">
                        <table class="table float float-none col-md-8">
                            <tr>
                                <th colspan="20">
                                    <h4>Integración por gastos</h4>
                                </th>
                                <th>
                                    <!-- Botón para imprimir -->
                                    <button class="btn btn-circle botonImprimir btn-lg" (click)="print()"><i class="mdi mdi-printer"></i></button>
                                    <!-- Botón para imprimir -->
                                </th>
                            </tr>
                            <tr class="tablasinborde">
                                <th>
                                    <h6>Fletes</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="fletes" [(ngModel)]="fletes" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>No deducibles</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="ndeducibles" [(ngModel)]="ndeducibles" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Maniobras</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="maniobras" [(ngModel)]="maniobras" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Boletos de avión</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="boletosAvion" [(ngModel)]="boletosAvion" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Hospedaje</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="hospedaje" [(ngModel)]="hospedaje" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Transporte</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="transporte" [(ngModel)]="transporte" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Alimentos</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="alimentos" [(ngModel)]="alimentos" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Casetas</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="casetas" [(ngModel)]="casetas" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Combustibles y lubricantes</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="combuylubri" [(ngModel)]="combuylubri" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Combustibles y lubricantes EDENRED</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="combuylubriEDEN" [(ngModel)]="combuylubriEDEN" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Combustibles y lubricantes (Apoyos)</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="combuylubriAPOYOS" [(ngModel)]="combuylubriAPOYOS" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>Gastos fletes</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="gastosfletes" [(ngModel)]="gastosfletes" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>No deducibles obra</h6>
                                </th>
                                <th>
                                    <input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="noDeduciblesObra" [(ngModel)]="noDeduciblesObra" required (ngModelChange)="mostrarseis()" />
                                </th>
                            </tr>
                            <tr>
                                <th>Total gastos</th>
                                <th>{{converoch}}</th>
                            </tr>
                            <!--
                                    <th>
                                    <input class="btn btn-secondary" type="submit" name="Enviar" id="ejemplo3" (click)="mostrarseis()" />
                                </th>
                                <tr class="float-left">
                                </tr>
                                -->

                        </table>
                    </div>
                    <!--====Cobranza Renta con IVA====-->
                    <!--Aqui-->
                    <div>
                        <table class="table table-hover">
                            <tr>
                                <th>Cobranza sin IVA venta</th>
                                <th>{{convercua}}</th>
                            </tr>
                        </table>
                    </div>
                    <!--====Fin cobranza renta con IVA====-->
                    <!--==================================-->
                    <hr>
                    <div>
                        <table class="table">
                            <tr>
                                <th>Total comisiones</th>
                                <th title="10% de total cobranza renta">
                                    <h6>10% Total cobranza renta:</h6> {{convercin}}</th>
                                <th> + </th>
                                <th title="5% de cobranza sin IVA renta">
                                    <h6>5% Cobranza sin IVA renta:</h6> {{conversei}}</th>
                                <th> = </th>
                                <th>{{conversie}}</th>
                            </tr>
                        </table>
                    </div>
                    <hr>
                    <!--=======Gerentes=======-->
                    <hr>
                    <div class="container col-lg-12">
                        <table class="table letra">
                            <tr>
                                <th>
                                    <h3>Pago por sueldos</h3>
                                </th>
                                <th>{{convernomina}}</th>
                            </tr>
                            <tr>
                                <th>Nómina: {{fgerente1}}</th>
                                <th><input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="nominanombre" [(ngModel)]="nominanombre" required (ngModelChange)="mostrarocho()" /></th>
                            </tr>
                            <tr>
                                <th>IMSS, AFORE E INFONAVIT</th>
                                <th><input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="nIAI" [(ngModel)]="nIAI" required (ngModelChange)="mostrarocho()" /></th>
                            </tr>
                            <tr>
                                <th>% Impuesto sobre nómina</th>
                                <th><input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="nImpuesto" [(ngModel)]="nImpuesto" required (ngModelChange)="mostrarocho()" /></th>
                                <!--<th><input class="btn btn-secondary" type="submit" name="Enviar" id="ejemplo3" (click)="mostrarocho()"></th>-->
                            </tr>
                        </table>
                    </div>
                    <!--=======Fin Gerentes=======-->
                    <!--=======PAGO DE SUELDOS=======-->
                    <hr>
                    <div class="container col-lg-12">
                        <table class="table table-danger letra tablasinborde">
                            <tr>
                                <th>TOTAL COMISIONES - SUELDOS</th>
                                <th>{{converdie}}</th>
                                <th></th>
                            </tr>
                            <tr>
                                <th>(-) SALDOS DE MÁS DE 90 DÍAS:</th>
                                <th><input class="sinborde" currencyMask [options]="{ prefix: '$ ', thousands: ',', decimal: '.', align: 'center' }" name="snoventa" [(ngModel)]="snoventa" required/></th>
                                <th></th>
                            </tr>
                            <tr>
                                <th>COMISIÓN TOTAL A REPARTIR:</th>
                                <th>{{converctr}}</th>
                                <th>
                                    <input class="btn btn-dark" type="submit" name="Enviar" id="ejemplo3" (click)="mostrarsiete()">
                                </th>
                            </tr>
                        </table>
                    </div>
                    <!--=======Fin pago de sueldos=======-->
                    <hr>
                    <div class="container">
                        <table class="table letra tablasinborde">
                            <tr>
                                <th>Nombre</th>
                                <th>%</th>
                                <th>Comisión</th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>{{fgerente1}}</h6>
                                </th>
                                <th>
                                    <h6>{{fporcentaje1}}</h6>
                                </th>
                                <th>{{convercom1}}</th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>{{fgerente2}}</h6>
                                </th>
                                <th>
                                    <h6>{{fporcentaje2}}</h6>
                                </th>
                                <th>{{convercom2}}</th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>{{fgerente3}}</h6>
                                </th>
                                <th>
                                    <h6>{{fporcentaje3}}</h6>
                                </th>
                                <th>{{convercom3}}</th>
                            </tr>
                            <tr>
                                <th>
                                    <h6>{{fgerente4}}</h6>
                                </th>
                                <th>
                                    <h6>{{fporcentaje4}}</h6>
                                </th>
                                <th>{{convercom4}}</th>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <th></th>
                                <th>{{convertotal}}</th>
                            </tr>
                        </table>
                    </div>
                    <!--==========================================-->
                    <hr>
                </form>

                <!-- Para imprimir -->
                <!-- ===================== -->
                <div id="print-section" style="display:none;">
                    <!-- style="display:none;" -->
                    <!-- style="visibility: hidden" -->
                    <table class="letraImprimir">
                        <tr>
                            <th>
                                <img src="../../../../assets/images/logoSm8.png" alt="85px" width="110px">
                            </th>
                            <th>
                                <h3> Cálculo de comisiones de {{ fnombre }}</h3>
                            </th>
                            <th>&nbsp;</th>
                            <th>
                                <h5>Meta: {{ fmeta }}</h5>
                                <h5>Fecha: {{ fecha }}</h5>
                            </th>
                        </tr>
                        <tr>
                            <th><br/></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Total cobrado en bancos:
                            </th>
                            <th></th>
                            <th></th>
                            <th>
                                $ {{ tcb }}
                            </th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Total cobrado por jurídico:
                            </th>
                            <th></th>
                            <th></th>
                            <th>
                                $ {{ tcj }}
                            </th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Cobranza externa:
                            </th>
                            <th></th>
                            <th></th>
                            <th>
                                $ {{ c_ext }}
                            </th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Total:
                            </th>
                            <th></th>
                            <th></th>
                            <th class="tablaIntegracionGastos">
                                {{ converuno }}
                            </th>
                        </tr>
                        <!--  -->
                        <tr>
                            <th style="text-align: left">
                                Cobranza renta con IVA:
                            </th>
                            <th></th>
                            <th>
                                $ {{ c_rrIVA }}
                            </th>
                            <th></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Cobranza venta con IVA:
                            </th>
                            <th></th>
                            <th>
                                $ {{ cvcI }}
                            </th>
                            <th></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Cobranza total según edo. cta.:
                            </th>
                            <th></th>
                            <th class="tablaIntegracionGastos">
                                {{ converdos }}
                            </th>
                            <th></th>
                        </tr>
                        <!--  -->
                        <tr>
                            <th style="text-align: left">
                                Cobranza sin IVA renta:
                            </th>
                            <th>{{ convertre }}</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Menos sueldos de montaje (horas extra):
                            </th>
                            <th>$ {{ menosSueldosMontaje }}</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Menos: Gastos:
                            </th>
                            <th>{{ converoch }}</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Total cobranza renta:
                            </th>
                            <th class="tablaIntegracionGastos">
                                {{ convernue }}
                            </th>
                            <th>10%</th>
                            <th>
                                {{convercin}}
                            </th>
                        </tr>
                        <tr>
                            <th><br></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                Cobranza sin IVA renta:
                            </th>
                            <th class="tablaIntegracionGastos">
                                {{ convercua }}
                            </th>
                            <th>5%</th>
                            <th>
                                {{conversei}}
                            </th>
                        </tr>
                        <tr>
                            <th><br></th>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th style="text-align: left">
                                Total comisiones
                            </th>
                            <th class="tablaIntegracionGastos" style="text-align: right">
                                {{conversie}}
                            </th>
                        </tr>
                    </table>
                    <table class="letraImprimir">
                        <tr>
                            <th>
                                Pago por sueldos
                            </th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>{{convernomina}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Nómina: {{fgerente1}}</th>
                            <th></th>
                            <th></th>
                            <th>
                                $ {{ nominanombre }}
                            </th>
                        </tr>
                        <tr>
                            <th style="text-align: left">IMSS, AFORE E INFONAVIT</th>
                            <th></th>
                            <th></th>
                            <th>
                                $ {{ nIAI }}
                            </th>
                        </tr>
                        <tr>
                            <th style="text-align: left">% Impuesto sobre nómina</th>
                            <th></th>
                            <th></th>
                            <th>
                                $ {{ nImpuesto }}
                            </th>
                        </tr>
                        <tr>
                            <th><br/></th>
                        </tr>
                    </table>
                    <table class="letraImprimir">
                        <tr>
                            <th>TOTAL COMISIONES - SUELDOS</th>
                            <th>&nbsp;</th>
                            <th>{{converdie}}</th>
                            <th></th>
                        </tr>
                        <tr>
                            <th>(-) SALDOS DE MÁS DE 90 DÍAS:</th>
                            <th>&nbsp;</th>
                            <th>
                                $ {{ snoventa }}
                            </th>
                            <th></th>
                        </tr>
                        <tr>
                            <th>COMISIÓN TOTAL A REPARTIR:</th>
                            <th>&nbsp;</th>
                            <th class="tablaIntegracionGastos">{{converctr}}</th>
                            <th></th>
                        </tr>
                        <tr>
                            <th><br/></th>
                        </tr>
                    </table>
                    <table class="letraImprimir">
                        <tr>
                            <th>Nombre</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>%</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>Comisión</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                {{fgerente1}}
                            </th>
                            <th></th>
                            <th style="text-align: left">
                                {{fporcentaje1}}
                            </th>
                            <th></th>
                            <th style="text-align: left">{{convercom1}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                {{fgerente2}}
                            </th>
                            <th></th>
                            <th style="text-align: left">
                                {{fporcentaje2}}
                            </th>
                            <th></th>
                            <th style="text-align: left">{{convercom2}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                {{fgerente3}}
                            </th>
                            <th></th>
                            <th style="text-align: left">
                                {{fporcentaje3}}
                            </th>
                            <th></th>
                            <th style="text-align: left">{{convercom3}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">
                                {{fgerente4}}
                            </th>
                            <th></th>
                            <th style="text-align: left">
                                {{fporcentaje4}}
                            </th>
                            <th></th>
                            <th style="text-align: right">{{convercom4}}</th>
                        </tr>
                        <tr>
                            <th>Total</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="tablaIntegracionGastos">{{convertotal}}</th>
                        </tr>
                    </table>
                    <table class="letraImprimir">
                        <tr>
                            <th><br/></th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Fletes</th>
                            <th style="visibility: hidden">Sin texto para impresión</th>
                            <th>$ {{fletes}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">No deducibles</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{ndeducibles}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Maniobras</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{maniobras}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Boletos de avión</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{boletosAvion}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Hospedaje</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{hospedaje}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Transporte</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{transporte}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Alimentos</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{alimentos}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Casetas</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{casetas}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Combustibles y lubircantes</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{combuylubri}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Consumibles y lubricantes EDENRED</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{combuylubriEDEN}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Consumibles y lubricantes (Apoyos)</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{combuylubriAPOYOS}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Gastos fletes</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{gastosfletes}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">No deducibles obra</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th>$ {{noDeduciblesObra}}</th>
                        </tr>
                        <tr>
                            <th style="text-align: left">Total Gastos:</th>
                            <th style="visibility: hidden">Sin texto</th>
                            <th class="tablaIntegracionGastos">$ {{converoch}}</th>
                        </tr>
                    </table>
                </div>
                <!-- ===================== -->
                <!-- Para imprimir -->

            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/comisiones/formulario/formulario.component.html